import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  FiHome, FiFileText, FiCreditCard, FiUsers, FiBell,
  FiActivity, FiLogOut, FiDollarSign
} from 'react-icons/fi';

const Sidebar = ({ onClose }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const role = user?.role;
  const isStaff = ['receptionniste', 'medecin', 'caissier', 'admin'].includes(role);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNavClick = () => {
    if (onClose) onClose();
  };

  const getInitials = () => {
    if (!user) return '?';
    return `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase();
  };

  const roleLabel = {
    patient: 'Patient',
    receptionniste: 'Réceptionniste',
    medecin: 'Médecin',
    caissier: 'Caissier',
    admin: 'Administrateur',
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">N</div>
        <div className="sidebar-brand">
          <h2>NomargueriPay</h2>
          <span>RD Congo</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {!isStaff ? (
          <>
            <div className="sidebar-section">
              <div className="sidebar-section-title">Menu Principal</div>
              <NavLink to="/patient" end className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                <FiHome /> Tableau de bord
              </NavLink>
              <NavLink to="/patient/invoices" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                <FiFileText /> Mes factures
              </NavLink>
              <NavLink to="/patient/payments" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                <FiCreditCard /> Mes paiements
              </NavLink>
              <NavLink to="/patient/notifications" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                <FiBell /> Notifications
              </NavLink>
            </div>
          </>
        ) : (
          <>
            <div className="sidebar-section">
              <div className="sidebar-section-title">Espace de travail</div>
              <NavLink to="/admin" end className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                <FiHome /> Tableau de bord
              </NavLink>

              {/* Factures — receptionniste, medecin, admin */}
              {(role === 'receptionniste' || role === 'medecin' || role === 'admin') && (
                <NavLink to="/admin/invoices" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                  <FiFileText /> Factures
                </NavLink>
              )}

              {/* Paiements & Transactions — caissier, admin */}
              {(role === 'caissier' || role === 'admin') && (
                <>
                  <NavLink to="/admin/payments" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                    <FiDollarSign /> Paiements
                  </NavLink>
                  <NavLink to="/admin/transactions" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                    <FiActivity /> Transactions
                  </NavLink>
                </>
              )}
            </div>

            {/* Gestion — admin uniquement */}
            {role === 'admin' && (
              <div className="sidebar-section">
                <div className="sidebar-section-title">Gestion</div>
                <NavLink to="/admin/users" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={handleNavClick}>
                  <FiUsers /> Utilisateurs
                </NavLink>
              </div>
            )}
          </>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{getInitials()}</div>
          <div className="sidebar-user-info">
            <div className="sidebar-user-name">{user?.first_name} {user?.last_name}</div>
            <div className="sidebar-user-role">{roleLabel[role] || role}</div>
          </div>
        </div>
        <button className="sidebar-link" onClick={handleLogout} style={{ width: '100%', color: 'var(--danger)' }}>
          <FiLogOut /> Déconnexion
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
